module.exports = __webpack_public_path__ + "static/media/navbar-ico-1-active.d0d4509a.svg";